import { getContentDomainTitle } from "@mobile/app/config/contentHeadingLabels";

import type { TargetLanguage } from "../appModel";
import type { LearningDomain } from "./webContentTypes";

export function domainTitle(domain: string, language: TargetLanguage): string {
  return getContentDomainTitle(domain as LearningDomain, language) || "";
}
